
      // Import and initialize comprehensive error monitoring
      import('./lib/errorMonitoring.js').then(() => {
        // error monitoring loads silently
      }).catch(err => {
        console.warn('⚠️ Error monitoring failed to load:', err);
        // Fallback error handling
        window.addEventListener('error', function(e) {
          var message = (e.error && e.error.message) || e.message || '';
          if (message.includes('attribute d: Expected number') ||
              /(^|[\s"'`])(?:t|s)c[-+0-9.,\s]+/i.test(message) ||
              message.includes('SVG') && message.includes('path')) {
            console.log('🔧 Fallback: Suppressed SVG error');
            e.preventDefault();
            return true;
          }
        }, true);
      });
    